import {IconArchive, IconFolderCog, IconFolderQuestion, IconQuestionMark} from "@tabler/icons-react";

export enum ProjectStatus {
    OPPORTUNITY = "Opportunity",
    PROJECT = "Project",
    ARCHIVED = "Archived",
}

export const ProjectStatuses = [
    ProjectStatus.OPPORTUNITY,
    ProjectStatus.PROJECT,
    ProjectStatus.ARCHIVED,
]

export function projectStatusToString(projectStatus: ProjectStatus) {
    switch (projectStatus) {
        case ProjectStatus.OPPORTUNITY:
            return "Planning"
        case ProjectStatus.PROJECT:
            return "Project"
        case ProjectStatus.ARCHIVED:
            return "Archived"
        default:
            return "Unknown ProjectStatus"
    }
}

export function projectStatusToStepNumber(projectStatus: ProjectStatus) {
    switch (projectStatus) {
        case ProjectStatus.OPPORTUNITY:
            return 1;
        case ProjectStatus.PROJECT:
            return 2;
        case ProjectStatus.ARCHIVED:
            return 3;
        default:
            return -1;
    }
}

export function projectStatusToColor(projectStatus: ProjectStatus) {
    switch (projectStatus) {
        case ProjectStatus.OPPORTUNITY:
            return "teal";
        case ProjectStatus.PROJECT:
            return "blue";
        case ProjectStatus.ARCHIVED:
            return "orange";
        default:
            return "black";
    }
}

export function projectStatusToDescription(projectStatus: ProjectStatus) {
    switch (projectStatus) {
        case ProjectStatus.OPPORTUNITY:
            return "Proposals and Estimates";
        case ProjectStatus.PROJECT:
            return "Active Project";
        case ProjectStatus.ARCHIVED:
            return "Completed Project";
        default:
            return "Unknown ProjectStatus";
    }
}

export function projectStatusToIcon(projectStatus: ProjectStatus) {
    switch (projectStatus) {
        case ProjectStatus.OPPORTUNITY:
            return <IconFolderQuestion/>
        case ProjectStatus.PROJECT:
            return <IconFolderCog/>
        case ProjectStatus.ARCHIVED:
            return <IconArchive/>
        default:
            return <IconQuestionMark/>
    }
}